export const calculateTotalWeight = (cartItems) => {
  const totalWeight = cartItems.reduce((weight, item) => {
    return weight + ((item.weight || 1.0) * item.quantity);
  }, 0);
  return Math.max(totalWeight, 0.5).toString();
};

export const calculateShipping = (cartItems, subtotal) => {
  if (subtotal >= 500) return 0;
  
  const totalWeight = cartItems.reduce((weight, item) => {
    return weight + ((item.weight || 0.5) * item.quantity);
  }, 0);
  
  if (totalWeight <= 1) return 10;
  if (totalWeight <= 3) return 15;
  if (totalWeight <= 5) return 25;
  if (totalWeight <= 10) return 35;
  return 45;
};

export const calculateShippingByAddress = (address, cartItems, subtotal, selectedRate) => {
  if (subtotal >= 500) return 0;
  
  if (selectedRate && selectedRate.amount) {
    return parseFloat(selectedRate.amount);
  }
  
  const localStates = ['GA', 'FL', 'AL', 'SC', 'NC', 'TN'];
  const isLocal = localStates.includes(address.state);
  
  const baseRate = isLocal ? 10 : 15;
  const totalWeight = parseFloat(calculateTotalWeight(cartItems));
  
  return baseRate + (Math.floor(totalWeight) * 3);
};
